<template>

	<span :class="{tile:forTile,active:has,table:!forTile,wrap:true}" @click="clicked">

		<span v-if="!forTile&&!show('setup')&&!show('setup-shared')" class="view">
			<span class="large-button mini" v-html="viewButtonLabel" />
		</span>

		<span v-if="theType==='data-dive'">

			<span class="large-button mini flip-colours no-case" v-if="show('setup')&&settings.click" @click="setUp">Set Up</span>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="(show('setup')||show('setup-shared'))&&!settings.click">

				<span class="stat-title">Not set up</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('fetching')">

				<span class="stat-title"><Icon type="ring-spin" class="svg" /> Fetching data...</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('pending')">

				<span class="stat-title"><Icon type="ring-spin" class="svg" /> Pending...</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('noData')">

				<span class="stat-title"><Icon type="warning" class="svg" colour="#d20000" /> No Data from GSC</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('errored')">

				<span class="stat-title"><Icon type="warning" class="svg" colour="#d20000" /> GSC/Analytics Error</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="settings.paused">

				<span class="stat-title">Paused</span>

			</div>

			<span v-if="show('stats')" :class="{'inline-stats-desktop': forTile, statWrap:true}">

				<div>

					<span 
						:class="{stat:true}"
						v-for="(stat, statIndex) in [{type:'impressions',label:'Impressions'},{type:'clicks',label:'Clicks'}]" 
						:key="'rt-stat-'+statIndex"
					>

						<span class="stat-title">{{stat.label}}</span> 

						<span class="stat-value bold">{{formatNumber(project.lastGraphStats.current[stat.type])}}</span>

						<span class="stat-value red bold" v-if="(!!project.lastGraphStats.history[stat.type]||project.lastGraphStats.history[stat.type]===0)&&project.lastGraphStats.history[stat.type]>project.lastGraphStats.current[stat.type]" v-html="'⇩'+formatNumber(project.lastGraphStats.history[stat.type]-project.lastGraphStats.current[stat.type])" />

						<span class="stat-value green bold" v-if="(!!project.lastGraphStats.history[stat.type]||project.lastGraphStats.history[stat.type]===0)&&project.lastGraphStats.current[stat.type]>project.lastGraphStats.history[stat.type]" v-html="'⇧'+formatNumber(project.lastGraphStats.current[stat.type]-project.lastGraphStats.history[stat.type])" />

					</span>

				</div>

				<span class="stat text-only re-fetching" v-if="show('reFetching')"><span class="stat-title"><Icon type="ring-spin" class="svg" /> Fetching new data...</span></span>

			</span>

			<span v-if="show('stats')" class="based">Based on 7 days of data</span>

		</span>

		<span v-if="theType==='rank-tracking'">

			<span class="large-button mini flip-colours no-case" v-if="show('setup')" @click="setUp">Set Up</span>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('setup-shared')">

				<span class="stat-title">Not setup.</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('empty')">

				<span class="stat-title">No keywords added.</span>

			</div>

			<div class="stat" v-if="show('stats2')">

				<span class="stat-title">Caddy Score</span>

				<span class="stat-value bold" v-html="project.caddyScore" />

			</div>

			<div class="stat" v-if="show('stats')">

				<span class="stat-title">Keywords Tracked</span>

				<span class="stat-value bold" v-html="project.keywordCount.keywordCount" />

				<span class="stat-value green bold" title="Gone Up" v-html="project.keywordCount.goneUp" v-if="project.keywordCount.keywordCount>0" />

				<span class="stat-value orange bold" title="The Same" v-html="project.keywordCount.same" v-if="project.keywordCount.keywordCount>0" />

				<span class="stat-value red bold" title="Gone Down" v-html="project.keywordCount.goneDown" v-if="project.keywordCount.keywordCount>0" />

			</div>

			<ProjectFeatures 
				:project="project"
				:show="['device','searchType','paused']"
				v-if="!forTile"
			/>

		</span>

		<span v-if="theType==='content-keywords'">

			<span class="large-button mini flip-colours no-case" v-if="show('setup')&&settings.click" @click="setUp">Set Up</span>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="(show('setup')||show('setup-shared'))&&!settings.click">

				<span class="stat-title">Not set up</span>

			</div>

			<div :class="{stat:true, 'text-only':!forTile}" v-if="show('stats')">

				<span class="stat-value"><span class="bold">{{has}}</span> <span v-html="'Keyword'+(has!==1?'s':'')+'/Topic'+(has!==1?'s':'')" /></span>

			</div>

		</span>

		<span v-if="theType==='weekly-insights'&&show('stats')">

			<div :class="{stat:true, 'text-only':!forTile}" style="display:none;">

				<span class="stat-value"><span class="bold">15 New Insights</span> This Week</span>

			</div>

			<span class="large-button mini no-case">View Weekly Insights</span>

		</span>

	</span>

</template>

<script>
import Icon from './Icon.vue'
import ProjectFeatures from './ProjectFeatures.vue'
import general from './../../utils/general'
export default {
  name: 'TableStats',
  components: { Icon, ProjectFeatures },
  props: {
	settings: {
	  type: Object,
	  default: () => {}
	},
	forTile: {
		type: Boolean,
		default: false
	}
  },
  data() {
	return {
		
	}
  },
  computed: {

	theType () {

		return !!this.settings && !!this.settings.theType ? this.settings.theType : '';


	},

	project () {

		return this.settings;

	},
	viewButtonLabel () {

		return 'View';

	},
	has () {

		return ( !!this.project && !!this.project.has ) ? this.project.has : 0;

	}

  },
  methods: {

	setUp() {
			
		this.$emit(this.forTile?'setUp':'clicked', this.project );

	},

	formatNumber (n) {

		return general.formatNumber(n);

	},
  
	clicked() {

		if ( !!this.has && !this.forTile ) {

			this.$router.push( this.project.url );

		}

	},

	show ( type ) {

		let project = this.project;

		if ( type === 'setup' ) {

			return !this.has && !project.shared;

		}

		if ( type === 'setup-shared' ) {

			return !this.has && !!project.shared;

		}

		if ( !this.has ) return false;

		switch (this.settings.theType) {

			case 'data-dive' :

				switch (type) {

					case 'fetching' :
					case 'reFetching' :
					case 'pending' :
					case 'errored' :
					case 'noData' :
						return this.settings[type];

					case 'stats' :

						return this.has&&project.lastGraphStats&&project.lastGraphStats.current;

				}

			break;

			case 'rank-tracking' :

				switch (type) {

					case 'empty' :

						return !this.settings.paused && this.settings.keywordCount.keywordCount===0;

					case 'fetching' :

						return this.settings.fetching;

					case 'stats' :

						return !project.paused&&this.has&&project.keywordCount.keywordCount>0;

					case 'stats2' :

						return !project.paused&&this.has&&project.caddyScore>0;

				}

			break;

			case 'content-keywords' :

				switch (type) {

					case 'stats' :

						return this.has;

				}

			break;

			case 'weekly-insights' :

				switch (type) {

					case 'stats' :

						return this.has;

				}

			break;

		}

	}

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';

.based {

	font-style: italic;
	font-size: 0.8em;

}
.statWrap {

	position: relative;
	z-index: 2;

}
.large-button {

	margin: 0;

}
.tile {
	.large-button {

		margin: 10px 0 0;

	}
}
.table {

	&:not(.active) {

		padding-right: 0 !important;
		display: block;
		text-align: left;

	}

	&.active {

		cursor: pointer;
		display: block;

		> span {

			.trans;

			&.view {

				opacity: 0;
				display: block;
				width: 100%;
				height: 100%;
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				z-index: 2;
				text-align: center;
				.vertical-align-parent;
				position: absolute;

				.large-button {

					display: block;
					.vertical-align;
					left: 0;
					width: 90px;
					background-color: #fff;
					border: 1px @darkContrast solid;
					color: @darkContrast;

				}

			}

		}

		&:hover {

			> span {

				&:not(.view) {

					opacity: 0;

				}

				&.view {

					opacity: 1;

				}

			}

		}

	}

}
.stat {

	margin: 2px 0 0;
	padding: 0;

	&.text-only {

		text-align: left;

	}

	&:not(.text-only) {

		display: flex;
		align-items: center;
		justify-content: flex-start;

	}

	&.re-fetching {

		display: block;
		padding: 5px 0;

	}

	span {

		display: inline-block;

		.svg {

			width: 20px;
			height: 20px;

		}

		span {

			display: inline;

		}

		&.stat-value {

			margin-left: 10px;

			&:first-child {
				margin-left: 0;
			}

		}

		&.green {

			color: @green;

		}	

		&.orange {

			color: @orange;

		}	

		&.red {

			color: @red;

		}

		&.bold {

			font-weight: @bold;

		}				

	}

}

.inline-stats {

	display: flex;
	align-items: center;
	justify-content: flex-start;

	.stat {

		margin-right: 30px;

		&:last-child {
			margin-right: 0;
		}

	}

}
@media screen and (min-width: 1024px) {
	.stat {

		span {

			font-size: 14px;			

		}

	}

	.inline-stats-desktop {

		> div {

			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-wrap: wrap;

		}

		.stat {

			margin-right: 20px;

			&:last-child {

				margin-right: 0;

			}

		}

	}
}
</style>